import type { RouteRecordRaw } from 'vue-router'
import Editor from './editor.vue'
import Page from './page.vue'

export default [
  {
    path: '/edit/:dockey/:mention',
    name: 'soykajs.docedit.mention',
    component: Editor,
    props: route => ({ dockey: route.params.dockey, mention: route.params.mention }),
    /** Без шапки и меню модуля — только документ R7. */
    meta: { hideAppChrome: true },
  },
  {
    path: '/edit/:dockey',
    name: 'soykajs.docedit',
    component: Editor,
    props: route => ({ dockey: route.params.dockey }),
    /** Без шапки и меню модуля — только документ R7. */
    meta: { hideAppChrome: true },
  },
  {
    path: '/docview/:filename',
    name: 'soykajs.docview',
    component: Page,
    props: route => {
      const formats = ['pdf', 'html']
      let format = String(route.params.format).toLowerCase()

      if (!formats.includes(format)) {
        format = 'pdf'
      }

      return { ...route.params, format }
    },
  },
] satisfies RouteRecordRaw[]
